import type { GetApiWarehousesData } from '@/api';

/*
 * Состояние списка складов в search params маршрута. Складов единицы - поиска,
 * сортировки и страниц нет, бэкенд отдаёт весь список по наименованию.
 */

export type ActivityFilter = 'active' | 'inactive' | 'all';

const DEFAULT_ACTIVITY: ActivityFilter = 'active';

export interface WarehousesSearch {
  activity?: ActivityFilter;
}

const isActivityFilter = (value: unknown): value is ActivityFilter =>
  value === 'active' || value === 'inactive' || value === 'all';

export const validateWarehousesSearch = (
  raw: Record<string, unknown>,
): WarehousesSearch =>
  isActivityFilter(raw.activity) && raw.activity !== DEFAULT_ACTIVITY
    ? { activity: raw.activity }
    : {};

export const resolveActivity = (search: WarehousesSearch): ActivityFilter =>
  search.activity ?? DEFAULT_ACTIVITY;

export const toWarehousesQuery = (
  activity: ActivityFilter,
): NonNullable<GetApiWarehousesData['query']> => {
  // Бэкенд по умолчанию отдаёт действующие - «действующие» не отправляем.
  if (activity === 'inactive') return { Activity: 'Inactive' };
  if (activity === 'all') return { Activity: 'All' };
  return {};
};
